var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74524 7.73653C7.40555 8.07621 6.85683 8.07621 6.51715 7.73653L4 5.22809L1.48285 7.74524C1.14317 8.08492 0.594447 8.08492 0.254763 7.74524C-0.0849211 7.40555 -0.0849211 6.85683 0.254763 6.51715L2.77191 4L0.254763 1.48285C-0.0849211 1.14317 -0.0849211 0.594447 0.254763 0.254763C0.594447 -0.0849211 1.14317 -0.0849211 1.48285 0.254763L4 2.77191L6.51715 0.263473C6.85683 -0.076211 7.40555 -0.076211 7.74524 0.263473C8.08492 0.603158 8.08492 1.15188 7.74524 1.49156L5.22809 4L7.74524 6.50844C8.07621 6.84812 8.07621 7.40555 7.74524 7.73653Z",
    fill: "#3D1CAF",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/XIcon.0ef7e623b70a6a009189946d6980bffc.svg";
export { ForwardRef as ReactComponent };